import React from "react";

export default function LibraryStore() {
    return (
        <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M13.8769 19.3572V8.53329C12.7457 8.17416 11.5487 8.00245 10.291 8.00003C8.93014 7.99743 7.49789 8.1934 6 8.56505V19.4159C8.62138 18.5481 11.276 18.4194 13.877 19.357L13.8769 19.3572Z"
                fill="#354F6C"/>
            <path
                d="M18.0315 8.10571C16.68 8.10983 15.3387 8.27925 14 8.57564V19.4359C16.7155 18.6253 19.369 18.5633 21.877 19.4046V8.5635C20.5821 8.2442 19.3022 8.10224 18.0314 8.10592L18.0315 8.10571Z"
                fill="#4F6E90"/>
        </svg>
    );
}
